import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {ServerForm} from '../models/servers';
import {LoadServerSuccessAction, serverActionTypes} from '../actions/servers';

export interface ServerState {
  array: ServerForm[];
}

const initialState: ServerState = {
  array: []
};

export function ServerReducer(state: ServerState = initialState, action: Action): ServerState {
  switch (action.type) {
    case serverActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case serverActionTypes.LOAD_FAIL:
    case serverActionTypes.CLEAR:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: ServerState, action: LoadServerSuccessAction): ServerState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleLoadFailAction(state: ServerState): ServerState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

export const serverSelectors = {
  array: (state: ServerState) => _.get(state, 'array', [])
};
